if (!customElements.get('responsive-video')) {
  customElements.define('responsive-video', class extends HTMLElement {
    connectedCallback() {
      this.galleryItem = this.closest('.product__media-item');
      this.desktopQuery = window.matchMedia(this.dataset.breakpoint || '(min-width: 750px)');
      this.syncSource = () => {
        if (!this.nearViewport) return;
        if (!this.getClientRects().length) {
          this.unload();
          this.activeTemplate = null;
          return;
        }
        const device = this.desktopQuery.matches ? 'desktop' : 'mobile';
        const template = this.querySelector(`template[data-device="${device}"]`) || this.querySelector('template:not([data-device])');
        if (template) {
          if (this.activeTemplate === template) {
            if (this.media?.autoplay) this.media.play().catch(() => {});
            return;
          }
          this.unload();
          this.activeTemplate = template;
          const content = template.content.cloneNode(true);
          content.querySelectorAll('video img:not([alt])').forEach(image => image.alt = '');
          if (this.querySelector('.responsive-video__poster')) {
            content.querySelector('video')?.removeAttribute('poster');
            content.querySelectorAll('video img').forEach(image => image.remove());
          }
          this.append(content);
          this.media = this.querySelector(':scope > video, :scope > iframe, :scope > img');
          this.classList.remove('is-playing');
          if (this.media?.tagName === 'VIDEO') {
            this.media.addEventListener('playing', () => this.classList.add('is-playing'), { once: true });
          } else if (this.media?.tagName === 'IMG') {
            if (this.media.complete) this.classList.add('is-playing');
            else this.media.addEventListener('load', () => this.classList.add('is-playing'), { once: true });
          } else if (this.media?.src.includes('autoplay=1')) {
            this.media.addEventListener('load', () => this.classList.add('is-playing'), { once: true });
          }
          if (this.media?.autoplay) this.media.play().catch(() => {});
          return;
        }
        this.media = this.querySelector('video');
        if (!this.media) return;
        const source = this.desktopQuery.matches ? this.dataset.desktopSrc : this.dataset.mobileSrc;
        if (!source || this.media.getAttribute('src') === source) return;
        this.media.src = source;
        this.media.load();
        if (this.media.autoplay) this.media.play().catch(() => {});
      };
      this.playMedia = (event) => {
        if (!event.target.closest('[data-video-play]')) return;
        this.nearViewport = true;
        this.syncSource();
        if (this.media?.tagName === 'VIDEO') this.media.play().catch(() => {});
        if (this.media?.tagName === 'IFRAME') {
          this.media.src = this.media.src.replace('autoplay=0', 'autoplay=1');
          this.classList.add('is-playing');
        }
      };
      this.addEventListener('click', this.playMedia);
      this.syncVisibility = () => {
        const selected = !this.galleryItem?.closest('.flickity-enabled') || this.galleryItem.classList.contains('is-selected');
        if (this.inViewport && selected) {
          this.nearViewport = true;
          this.syncSource();
        } else if (this.galleryItem) {
          this.nearViewport = false;
          if (this.media?.tagName === 'VIDEO') this.media.pause();
          else {
            this.unload();
            this.activeTemplate = null;
          }
        }
      };
      this.observer = new IntersectionObserver((entries) => {
        this.inViewport = entries[0].isIntersecting;
        this.syncVisibility();
      }, { rootMargin: this.galleryItem ? '0px' : '200px' });
      this.observer.observe(this);
      if (this.galleryItem) {
        this.galleryObserver = new MutationObserver(this.syncVisibility);
        this.galleryObserver.observe(this.galleryItem, { attributes: true, attributeFilter: ['class'] });
        this.galleryObserver.observe(this.galleryItem.closest('.product__media-list'), { attributes: true, attributeFilter: ['class'] });
      }
      this.desktopQuery.addEventListener('change', this.syncSource);
    }

    unload() {
      if (!this.media) return;
      if (this.media.tagName === 'VIDEO') {
        this.media.pause();
        this.media.removeAttribute('src');
        this.media.querySelectorAll('source').forEach(source => source.remove());
        this.media.load();
      }
      this.media.remove();
      this.media = null;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.galleryObserver?.disconnect();
      this.desktopQuery?.removeEventListener('change', this.syncSource);
      this.removeEventListener('click', this.playMedia);
      this.unload();
      this.activeTemplate = null;
    }
  });
}

if (!customElements.get('video-selector')) {
  customElements.define('video-selector', class extends HTMLElement {
    connectedCallback() {
      this.selectVideo = (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        const selectedId = event.target.value;
        this.querySelectorAll('responsive-video').forEach(player => {
          const selected = player.id === `video-${selectedId}`;
          player.style.display = selected ? 'block' : 'none';
          if (selected) {
            player.nearViewport = true;
            player.syncSource?.();
          } else {
            player.unload?.();
            player.activeTemplate = null;
          }
        });
        this.querySelectorAll('.leggings-description').forEach(description => {
          description.style.display = description.id === `description-${selectedId}` ? 'block' : 'none';
        });
      };
      this.addEventListener('change', this.selectVideo);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.selectVideo);
    }
  });
}
